module.exports = __webpack_public_path__ + "img/iconic.378959e9.png";